document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('product-grid');
  const toggles = document.querySelectorAll('.view-toggle');

  toggles.forEach((btn) => {
    btn.addEventListener('click', () => {
      const columns = btn.getAttribute('data-columns');
      grid.setAttribute('data-columns', columns);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('product-grid');
  const toggles = document.querySelectorAll('.view-toggle');

  toggles.forEach((btn) => {
    btn.addEventListener('click', () => {
      const columns = btn.getAttribute('data-columns');
      grid.setAttribute('data-columns', columns);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('product-grid');
  const toggles = document.querySelectorAll('.view-toggle');

  const sortByPanel = document.getElementById('sortby-panel');
  const sortByToggleMobile = document.getElementById('sortby-toggle-mobile');
  const sortbyClose = document.getElementById('sortby-close');

  toggles.forEach((btn) => {
    btn.addEventListener('click', () => {
      const columns = btn.getAttribute('data-columns');
      grid.setAttribute('data-columns', columns);
    });
  });

  sortByToggleMobile?.addEventListener('click', () => {
    sortByPanel?.classList.add('active');
  });

  sortbyClose?.addEventListener('click', () => {
    sortByPanel?.classList.remove('active');
  });
});

document.querySelectorAll('input[name="sort_by"]').forEach((radio) => {
  radio.addEventListener('change', () => {
    document.getElementById('FacetsForm').submit();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const toggleButtons = document.querySelectorAll('.view-toggle');

  toggleButtons.forEach((button) => {
    button.addEventListener('click', () => {
      // Remueve clase active de todos
      toggleButtons.forEach((btn) => btn.classList.remove('active'));
      // Agrega clase active al actual
      button.classList.add('active');

      // Aplica el cambio visual al grid si es necesario
      const grid = document.getElementById('product-grid');
      if (grid && button.dataset.columns) {
        grid.setAttribute('data-columns', button.dataset.columns);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  function adjustFeaturedItems() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    // Uniform grid — no featured 2x2 tiles
    grid.querySelectorAll('.collection-item.featured').forEach((item) => item.classList.remove('featured'));
  }

  window.ClarezaCollection = window.ClarezaCollection || {};
  window.ClarezaCollection.adjustFeaturedItems = adjustFeaturedItems;

  adjustFeaturedItems();

  document.querySelectorAll('.view-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const columns = btn.getAttribute('data-columns');
      grid.setAttribute('data-columns', columns);
      document.querySelectorAll('.view-toggle').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      setTimeout(adjustFeaturedItems, 10);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#FacetsForm');
  if (!form) return;

  form.querySelectorAll('input, select').forEach((input) => {
    const excluded = ['price-min', 'price-max', 'price-gte-input', 'price-lte-input', 'apply-price-range'];
    if (excluded.includes(input.id)) return; // Ignorar controles de precio

    input.addEventListener('change', () => {
      form.submit();
    });
  });
});

/* document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.filter-remove[data-remove-tag]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const tagToRemove = el.dataset.removeTag;
      const url = new URL(window.location.href);
      const pathname = '/collections/all-products';
      const searchParams = new URLSearchParams(url.search);

      // Eliminar el tag de los filtros activos si existiera
      const tagParamKey = 'filter.p.tag';
      const currentTags = searchParams.getAll(tagParamKey);
      const newTags = currentTags.filter((tag) => tag !== tagToRemove);

      searchParams.delete(tagParamKey);
      newTags.forEach((tag) => searchParams.append(tagParamKey, tag));

      window.location.href = `${pathname}?${searchParams.toString()}`;
    });
  });
});
 */

/* document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.filter-remove[data-remove-part]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const partToRemove = el.dataset.removePart;
      const path = window.location.pathname;
      const currentHandle = path.split('/collections/')[1];
      const handleParts = currentHandle.split('-');
      const newParts = handleParts.filter((p) => p.toLowerCase() !== partToRemove.toLowerCase());
      const newHandle = newParts.length > 0 ? newParts.join('-') : 'all-products';
      const query = window.location.search;
      window.location.href = `/collections/${newHandle}${query}`;
    });
  });
}); */

const ALL_HANDLE = 'all-products';

function parseCollectionSegments() {
  const path = location.pathname.toLowerCase();
  const after = (path.split('/collections/')[1] || '').split('?')[0];
  const rawSegs = after.split('/').filter(Boolean);
  const segs = rawSegs.filter((s) => s !== 'tagged'); // por si llega /tagged/...
  return segs;
}

function renderCollectionChips() {
  const container = document.querySelector('[data-collection-chips]');
  if (!container) return;
  container.innerHTML = '';

  const segs = parseCollectionSegments();
  if (!segs.length) return;

  const prettyTypeSeg = (window.__prettyTypeSeg || '').toLowerCase();
  const activeTypeSet = new Set(getActiveProductTypes().map(slugifyPath));

  segs.forEach((seg, idx) => {
    const slug = seg.toLowerCase();

    // no mostrar /collections/all(-products)
    if (idx === 0 && (slug === 'all' || slug === 'all-products')) return;

    // ocultar el segmento "bonito" que representa TYPE (ya existe chip nativo TYPE: ...)
    if (prettyTypeSeg && slug === prettyTypeSeg) return;

    // si es combinado (earring+rings), no mostrar si alguna parte ya está activa como TYPE
    if (slug.includes('+')) {
      const parts = slug.split('+');
      if (parts.some((p) => activeTypeSet.has(p))) return;
    }

    const chip = document.createElement('div');
    chip.className = 'active-filter';
    chip.innerHTML = `
      ${seg.replace(/-/g, ' ').toUpperCase()}
      <a href="#" class="filter-remove" data-remove-seg="${seg}">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
          <path d="M1 1L8.08333 8.28571" stroke="black"/>
          <path d="M8.08337 1L1.00004 8.28571" stroke="black"/>
        </svg>
      </a>
    `;
    container.appendChild(chip);
  });

  window.__chips_last = { pathname: location.pathname, segs };
}

function slugifyPath(v) {
  return v
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

function getActiveProductTypes() {
  const qs = new URLSearchParams(location.search);
  const fromQuery = qs.getAll('filter.p.product_type');
  if (fromQuery.length) return fromQuery;

  const inputs = document.querySelectorAll('input[name="filter.p.product_type"]');
  const checked = [];
  inputs.forEach((el) => {
    if (el.checked) checked.push(el.value);
  });
  return checked;
}

function applyPrettyProductType() {
  // Only rewrite URLs on collection pages — never on /search (breaks back-button → 404).
  if (!location.pathname.includes('/collections/')) return;

  const url = new URL(location.href);
  const parts = url.pathname.split('/').filter(Boolean);
  const i = parts.indexOf('collections');
  const collection = parts[i + 1] || ALL_HANDLE;

  const types = getActiveProductTypes();
  const seg = types.length ? types.map(slugifyPath).join('+') : '';

  const newParams = new URLSearchParams(url.search);
  newParams.delete('filter.p.product_type'); // ocultamos el param en la barra

  const newPath = ['', 'collections', collection].concat(seg ? [seg] : []).join('/');
  const newUrl = newPath + (newParams.toString() ? `?${newParams}` : '');

  if (location.pathname + location.search !== newUrl) {
    history.replaceState({ pretty: 1 }, '', newUrl);
  }

  // guardamos qué segmento representa el TYPE "bonito"
  window.__prettyTypeSeg = seg || '';
  if (window.renderCollectionChips) renderCollectionChips();
}

document.addEventListener('DOMContentLoaded', () => {
  applyPrettyProductType();
});

['shopify:section:load', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:reorder'].forEach(
  (evt) => document.addEventListener(evt, applyPrettyProductType)
);

document.addEventListener('change', (e) => {
  if (!(e.target && e.target.matches('input[name="filter.p.product_type"]'))) return;

  // Comportamiento radio (opcional)
  document.querySelectorAll('input[name="filter.p.product_type"]').forEach((inp) => {
    if (inp !== e.target) inp.checked = false;
  });

  const current = new URL(location.href);
  const parts = current.pathname.split('/').filter(Boolean);
  const i = parts.indexOf('collections');
  const collection = parts[i + 1] || 'all-products';

  // Conserva otros filtros y sólo cambia el product_type
  const params = new URLSearchParams(current.search);
  params.set('filter.p.product_type', e.target.value);

  location.href = ['', 'collections', collection].join('/') + `?${params.toString()}`;
});

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="filter.p.product_type="]');
  if (!link) return;

  const rawHref = link.getAttribute('href') || '';

  // Si el enlace ya apunta a otra colección (/collections/{handle}...),
  // NO lo interceptes: deja que el navegador navegue normal.
  if (rawHref.includes('/collections/')) {
    return; // ← no hacemos preventDefault
  }

  // Solo interceptamos los enlaces "internos" del facet (href como "?filter...")
  e.preventDefault();

  const target = new URL(rawHref, location.href);
  const newType = target.searchParams.get('filter.p.product_type');
  if (!newType) return;

  const current = new URL(location.href);
  const parts = current.pathname.split('/').filter(Boolean);
  const i = parts.indexOf('collections');
  const collection = parts[i + 1] || ALL_HANDLE;

  // Conserva otros filtros actuales y reemplaza el product_type por el nuevo
  const params = new URLSearchParams(current.search);
  params.set('filter.p.product_type', newType);

  // Si el link trae otros params (precio/material), mézclalos también
  target.searchParams.forEach((val, key) => {
    if (key !== 'filter.p.product_type') params.set(key, val);
  });

  // Navega a la MISMA colección actual con el nuevo type en query.
  // (applyPrettyProductType lo convertirá a /{type} al cargar)
  location.href = ['', 'collections', collection].join('/') + `?${params.toString()}`;
});

/* // Ejecutar al cargar y tras renders de secciones
document.addEventListener('DOMContentLoaded', applyPrettyProductType);
document.addEventListener('shopify:section:load', applyPrettyProductType);
document.addEventListener('shopify:section:select', applyPrettyProductType);
document.addEventListener('shopify:section:deselect', applyPrettyProductType); */

/* document.addEventListener('DOMContentLoaded', renderCollectionChips);
// Si tu grid/panel se re-renderiza vía Section Rendering, vuelve a pintar:
document.addEventListener('shopify:section:load', renderCollectionChips);
document.addEventListener('shopify:section:reorder', renderCollectionChips);
document.addEventListener('shopify:section:select', renderCollectionChips);
document.addEventListener('shopify:section:deselect', renderCollectionChips); */

// Quitar un segmento concreto (conserva ?filter=...)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.filter-remove[data-remove-seg]');
  if (!btn) return;
  e.preventDefault();

  const segToRemove = (btn.dataset.removeSeg || '').toLowerCase();
  const url = new URL(location.href);
  const parts = url.pathname.split('/').filter(Boolean); // ['collections','fine-jewelry','rings','gold']
  const i = parts.indexOf('collections');
  if (i === -1) return;

  const segs = parts.slice(i + 1).filter((s) => s && s.toLowerCase() !== 'tagged');
  const newSegs = segs.filter((s) => s.toLowerCase() !== segToRemove);
  const base = newSegs.length ? newSegs : [ALL_HANDLE];
  const newPath = ['', 'collections', ...base].join('/');

  location.href = newPath + url.search;
});

document.addEventListener('DOMContentLoaded', function () {
  const priceWrap = document.querySelector('.price-range-filter');
  const minSlider = document.getElementById('price-min');
  const maxSlider = document.getElementById('price-max');
  const applyBtn = document.getElementById('apply-price-range');
  const minValLabel = document.getElementById('range-min-val');
  const maxValLabel = document.getElementById('range-max-val');
  const gteInput = document.getElementById('price-gte-input');
  const lteInput = document.getElementById('price-lte-input');

  if (!priceWrap || !minSlider || !maxSlider || !applyBtn || !minValLabel || !maxValLabel) {
    return;
  }

  const rangeMin = Number(priceWrap.dataset.rangeMin || minSlider.min || 0);
  const rangeMax = Number(priceWrap.dataset.rangeMax || maxSlider.max || 0);
  let activeMin = Number(priceWrap.dataset.activeMin || minSlider.value || rangeMin);
  let activeMax = Number(priceWrap.dataset.activeMax || maxSlider.value || rangeMax);

  if (!isFinite(rangeMin) || !isFinite(rangeMax) || rangeMax <= rangeMin) {
    minSlider.disabled = true;
    maxSlider.disabled = true;
    applyBtn.disabled = true;
    const sliderContainer = document.querySelector('.range-slider');
    if (sliderContainer) {
      sliderContainer.style.opacity = '0.4';
      sliderContainer.style.pointerEvents = 'none';
    }
    return;
  }

  minSlider.min = rangeMin;
  minSlider.max = rangeMax;
  maxSlider.min = rangeMin;
  maxSlider.max = rangeMax;

  activeMin = Math.max(rangeMin, Math.min(activeMin, rangeMax));
  activeMax = Math.max(rangeMin, Math.min(activeMax, rangeMax));
  if (activeMin > activeMax) [activeMin, activeMax] = [activeMax, activeMin];

  minSlider.value = activeMin;
  maxSlider.value = activeMax;

  function readRange() {
    let minVal = Math.round(parseFloat(minSlider.value));
    let maxVal = Math.round(parseFloat(maxSlider.value));
    if (minVal > maxVal) [minVal, maxVal] = [maxVal, minVal];
    return { minVal, maxVal };
  }

  function updateDisplay() {
    const { minVal, maxVal } = readRange();
    minValLabel.textContent = minVal.toLocaleString();
    maxValLabel.textContent = maxVal.toLocaleString();
  }

  function setNativePriceInputs(minVal, maxVal) {
    if (!gteInput || !lteInput) return;
    gteInput.disabled = false;
    lteInput.disabled = false;
    gteInput.value = String(minVal);
    lteInput.value = String(maxVal);
  }

  function clearNativePriceInputs() {
    if (!gteInput || !lteInput) return;
    gteInput.value = '';
    lteInput.value = '';
    gteInput.disabled = true;
    lteInput.disabled = true;
  }

  function productMatchesPrice(item, minVal, maxVal) {
    const info = item.querySelector('.product-info');
    if (!info) return true;
    const pMin = parseFloat(info.dataset.priceMin);
    const pMax = parseFloat(info.dataset.priceMax);
    if (isNaN(pMin) && isNaN(pMax)) return true;
    const low = !isNaN(pMin) ? pMin : pMax;
    const high = !isNaN(pMax) ? pMax : pMin;
    return low <= maxVal && high >= minVal;
  }

  function applyClientPriceFilter(minVal, maxVal) {
    const grid = document.getElementById('product-grid');
    if (!grid) return 0;

    let visible = 0;
    grid.querySelectorAll('.collection-item').forEach((item) => {
      const match = productMatchesPrice(item, minVal, maxVal);
      item.hidden = !match;
      item.style.display = match ? '' : 'none';
      if (match) visible += 1;
    });

    let empty = grid.querySelector('[data-price-empty]');
    if (visible === 0) {
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'empty-collection-message';
        empty.setAttribute('data-price-empty', 'true');
        empty.style.cssText = 'grid-column: 1 / -1; text-align:center; padding: 24px 12px;';
        empty.innerHTML =
          '<p style="margin:0;">Unfortunately there are no results matching your request.</p>';
        grid.appendChild(empty);
      }
      empty.hidden = false;
    } else if (empty) {
      empty.hidden = true;
    }

    return visible;
  }

  function clearClientPriceFilter() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.querySelectorAll('.collection-item').forEach((item) => {
      item.hidden = false;
      item.style.display = '';
    });
    const empty = grid.querySelector('[data-price-empty]');
    if (empty) empty.hidden = true;
  }

  function syncPriceChip(minVal, maxVal) {
    const container = document.querySelector('.collection-controls-left');
    if (!container) return;
    container.querySelectorAll('.active-filter[data-price-chip]').forEach((el) => el.remove());

    const chip = document.createElement('div');
    chip.className = 'active-filter';
    chip.setAttribute('data-price-chip', 'true');
    chip.setAttribute('data-open-filters', 'true');
    chip.innerHTML = `
      PRICE: $${minVal.toLocaleString()} - $${maxVal.toLocaleString()}
      <a href="#" class="filter-remove" data-clear-price aria-label="Clear price filter">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
          <path d="M1 1L8.08333 8.28571" stroke="black"/>
          <path d="M8.08337 1L1.00004 8.28571" stroke="black"/>
        </svg>
      </a>
    `;
    chip.querySelector('[data-clear-price]')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearNativePriceInputs();
      clearClientPriceFilter();
      window.ClarezaCollection?.adjustFeaturedItems?.();
      const next = new URL(window.location.href);
      next.searchParams.delete('filter.v.price.gte');
      next.searchParams.delete('filter.v.price.lte');
      window.location.href = next.pathname + (next.searchParams.toString() ? `?${next.searchParams}` : '');
    });
    container.appendChild(chip);
  }

  function applyPriceFilter(minVal, maxVal) {
    setNativePriceInputs(minVal, maxVal);
    const url = new URL(window.location.href);
    url.searchParams.set('filter.v.price.gte', String(minVal));
    url.searchParams.set('filter.v.price.lte', String(maxVal));
    history.replaceState({}, '', url.toString());
    applyClientPriceFilter(minVal, maxVal);
    window.ClarezaCollection?.adjustFeaturedItems?.();
    syncPriceChip(minVal, maxVal);
  }

  // Keep Dawn facets.js from treating slider drags as facet form submits
  [minSlider, maxSlider].forEach((slider) => {
    ['input', 'change'].forEach((evt) => {
      slider.addEventListener(evt, (e) => {
        e.stopPropagation();
        if (evt === 'input') updateDisplay();
      });
    });
  });
  updateDisplay();

  applyBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const { minVal, maxVal } = readRange();
    applyPriceFilter(minVal, maxVal);
    document.getElementById('filters-panel')?.classList.remove('active', 'open');
    const overlay = document.getElementById('FiltersOverlay');
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
  });

  // On load: enforce price from URL (Shopify often ignores these query params here)
  const url = new URL(window.location.href);
  const urlMin = url.searchParams.get('filter.v.price.gte');
  const urlMax = url.searchParams.get('filter.v.price.lte');
  if (urlMin || urlMax) {
    let minVal = Math.round(Number(urlMin || rangeMin));
    let maxVal = Math.round(Number(urlMax || rangeMax));

    // Drop historic broken URLs from cents/dollars confusion (e.g. 55440 when max ~6k)
    if (minVal > rangeMax * 1.05 || maxVal > rangeMax * 1.05) {
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : ''));
      return;
    }

    minVal = Math.max(rangeMin, Math.min(minVal, rangeMax));
    maxVal = Math.max(rangeMin, Math.min(maxVal, rangeMax));
    if (minVal > maxVal) [minVal, maxVal] = [maxVal, minVal];

    minSlider.value = minVal;
    maxSlider.value = maxVal;
    updateDisplay();
    applyPriceFilter(minVal, maxVal);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.swatch-link[data-image]').forEach((link) => {
    link.addEventListener('mouseenter', (e) => {
      const wrapper = e.currentTarget.closest('.collection-item');
      const image = wrapper?.querySelector('.js-product-image');
      if (image && e.currentTarget.dataset.image) {
        image.src = e.currentTarget.dataset.image;
      }
    });
  });

  document.querySelectorAll('.variant-swatch-input').forEach((input) => {
    input.addEventListener('change', (e) => {
      const wrapper = e.target.closest('.collection-item');
      const image = wrapper.querySelector('.js-product-image');
      const price = wrapper.querySelector('.js-product-price');

      if (image && e.target.dataset.image) image.src = e.target.dataset.image;
      if (price && e.target.dataset.price) price.innerHTML = e.target.dataset.price;
    });
  });
});

function openFiltersPanel() {
  window.ClarezaDrawers?.open('filters');
  const filtersPanel = document.getElementById('filters-panel');
  const filtersOverlay = document.getElementById('FiltersOverlay');
  filtersPanel?.classList.add('active');
  if (filtersOverlay) filtersOverlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function closeFiltersPanel() {
  document.getElementById('filters-panel')?.classList.remove('active', 'open');
  document.getElementById('sortby-panel')?.classList.remove('active', 'open');
  const filtersOverlay = document.getElementById('FiltersOverlay');
  if (filtersOverlay) filtersOverlay.style.display = 'none';
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('filters-toggle')?.addEventListener('click', openFiltersPanel);
  document.getElementById('filters-toggle-mobile')?.addEventListener('click', openFiltersPanel);
  document.getElementById('filters-close')?.addEventListener('click', closeFiltersPanel);
  document.getElementById('FiltersOverlay')?.addEventListener('click', closeFiltersPanel);

  document.getElementById('sortby-toggle-mobile')?.addEventListener('click', () => {
    window.ClarezaDrawers?.open('filters');
    document.getElementById('sortby-panel')?.classList.add('active');
    const filtersOverlay = document.getElementById('FiltersOverlay');
    if (filtersOverlay) filtersOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  });
  document.getElementById('sortby-close')?.addEventListener('click', closeFiltersPanel);

  // Clicking an active filter chip opens the filters panel (X still clears)
  document.querySelector('.collection-controls-left')?.addEventListener('click', (e) => {
    const remove = e.target.closest('.filter-remove');
    if (remove) return;
    const chip = e.target.closest('.active-filter');
    if (!chip) return;
    if (chip.hasAttribute('data-open-filters') || chip.hasAttribute('data-price-chip')) {
      openFiltersPanel();
    }
  });
});

document.querySelectorAll('.filters-group').forEach((group) => {
  const label = group.querySelector('summary')?.textContent?.trim();
  if (label === 'ALL PRODUCTS') {
    group.style.display = 'none';
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const productType = urlParams.get('filter.p.product_type');
  const tags = urlParams.getAll('filter.p.tag');
  const title = document.querySelector('.collection-title');

  if (!title) return;

  let finalTitle = 'ALL PRODUCTS';

  if (productType) {
    finalTitle = productType;
  } else if (tags.length > 0) {
    finalTitle = tags[0];
  } else {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    if (pathParts[0] === 'collections' && pathParts[1] && pathParts[1] !== 'all-products') {
      finalTitle = pathParts[1];
    }
  }

  title.textContent = finalTitle.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
});

document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);

  const controls = document.querySelector('.collection-controls-right-mobile');
  const collectionGrid = document.querySelector('.collection-grid');

  if (controls && collectionGrid) {
    ScrollTrigger.create({
      trigger: collectionGrid,
      start: 'bottom+=30% bottom',
      end: 'bottom+1 bottom',
      onEnter: () => gsap.set(controls, { display: 'none' }),
      onLeaveBack: () => gsap.set(controls, { display: 'flex' }),
    });
  }
});
